import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = [ "positionField" ]

  connect() {
    const options = {
      swap: true,
      animation: 150,
      group: this.element.dataset.sortableGroup,
      handle: this.element.dataset.sortableHandle,
      onEnd: () => this.#syncPosition()
    }
    this.sortable = new Sortable(this.element, options)
  }

  #syncPosition() {
    if (this.hasPositionFieldTarget) {
      this.positionFieldTargets.forEach((n, i) => { n.value = i })
    }
  }
}
